<template>
  <div class="login"  v-show="isFS">
    <header class="login-header">
      <div class="left">
        <img class="logo" :src="loginIcon" alt />
        <van-dropdown-menu class="account-list">
          <van-dropdown-item v-model="currentAccount" :options="accountList" />
        </van-dropdown-menu>
      </div>
      <div class="right"></div>
    </header>
    <van-cell-group>
      <van-field clearable label="用户名" v-model="user" placeholder="请输入用户名"></van-field>
      <van-field
        :type="this.passwordType"
        label="密码"
        v-model="pwd"
        placeholder="请输入密码"
        right-icon="eye-o"
        @click-right-icon="toggleSee"
      ></van-field>
    </van-cell-group>

    <div class="login-btn">
      <van-button type="info" round @click="loginBtn">登录</van-button>
    </div>
    <p @click="onAppointment" class="login-btn-footer" >访客预约 > </p>
    <!-- <van-button type="info" style="position: absolute;right: 10%;bottom: 5%;font-size:14px" round @click="visitBtn">访客</van-button> -->
      
  </div>
</template>
<script>
import * as dd from "dingtalk-jsapi";
const loginIcon = require("@/assets/Login-logo.png");
export default {
  name: "Login",
  data() {
    return {
      isFS:false,
      passwordType: "password",
      loginIcon: loginIcon,
      accountList: [],
      currentAccount: "",
      user: "",
      pwd: "",

      // wechat
      accountID: "",
      openID: "",

      // dingtalt
      code: {},
      dingUseId: "",
      notInDingTalk: "" // 是否来自钉钉
    };
  },
  created() {
    this.notInDingTalk = dd.env.platform === "notInDingTalk";
      if (!this.notInDingTalk) {
        this.dingTalkInfo();
      } else {
        this.getURLInfo();
      }
  },
  watch:{
    currentAccount(val){
      if(val){
        localStorage.setItem('accountId',val)
      }
    }
  },
  methods: {
    getURLInfo() {
      if (window.location.href.indexOf("?") > -1) {
        let localUrl = window.location.href.split("?")[1];
        let items = localUrl.split("&");
        let item;
        for (let i = 0; i < items.length; i++) {
          item = items[i].split("=");
          if (item[0].toLowerCase() === "accountid") {
            this.accountID = item[1];
          }
          if (item[0].toLowerCase() === "openid") {
            this.openID = item[1];
          }
          if (item[0].toLowerCase() === "token") {
            this.xy.setCookie(item[1])
            this.xy.msgSuc('登录成功')
            // this.$router.push('/xyIndex')
           // this.$router.push({path:'/home/visitList'});
             this.$router.push({path:'/home/VisitApplyDetails'});
          }
        }
      }else{
        this.isFS = true
      }
      this.weChatLogin();
    },
    //钉钉授权
    dingTalkInfo() {
      dd.ready(()=> {
        dd.runtime.permission.requestAuthCode({
          // TODO: 发布正式站时需要调整，详见 README.md 以进行修改
          corpId: this.corpId,
          onSuccess: function(result) {
            this.getUserMsg(result)
          },
          onFail: function(err) {
            console.log(err)
          }
        })
      })
    },

    // 钉钉获取用户id
    async getUserMsg(DDResult) {
      this.xy.loading();
      let code = {
        Code: DDResult.code.toString()
      };
      let res = await this.xyapi.get(
        this.xyMApi + "/api/DingTalk/GetDDUserInfoByCode",
        code
      );
      if (res.success) {
        this.dingUseId = res.data.userid;
        this.getAccountInfo();
      }
    },

    // 钉钉登陆
    async dingTalkLogin() {
      let params = {
        AccountID: this.accountList[0].value,
        DtUserID: this.dingUseId
      };
      let res = await this.xyapi.post(
        this.xyMApi + "/xy/login/DingTalkLogin",
        params
      );
      this.xy.unloading();
      if (res.success) {
        window.localStorage.setItem("webSiteTitle", this.accountList[0].text);
        this.xy.setCookie(res.data.token);
        localStorage.setItem("role", res.data.role);
        if (this.xy.getCookie(".XYTOKEN")) {
          // let routers =
          //   localStorage.getItem("role") === "4" ? "/xyParent" : "/xyIndex";
          // this.$router.push(routers);
          //this.$router.push({path:'/home/visitList'});
            this.$router.push({path:'/home/VisitApplyDetails'});
        } else {
          this.xy.msgError("登录失败");
        }
      }
    },

    weChatLogin() {
      if (this.accountID > 0 && this.openID !== "") {
        this.getWeChatUserInfo();
      } else {
        this.getAccountInfo();
      }
    },
    async getWeChatUserInfo() {
      let LoginViewModel = {
        AccountID: this.accountID,
        OpenID: this.openID
      };
      this.xy.loading();
      let res = await this.xyapi.post(
        this.xyMApi + "/xy/login",
        LoginViewModel
      );
      if (res.success) {
        this.xy.removeCookie('.XYTOKEN')
        localStorage.setItem("role", res.data.role);
        this.xy.setCookie(res.data.token);
        this.getOneAccountInfo();
      } else {
        this.xy.msgError(res.data.msg);
      }
      this.xy.unloading();
    },
    toggleSee() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    async loginBtn() {
      this.xy.loading();
      let params = {
        AccountID: this.currentAccount,
        LoginId: this.user,
        Password: this.xy.encrypt(this.pwd)
      };
      let res = await this.xyapi.post(
        this.xyMApi + "/xy/login",
        params
      );
      if (res.success) {
        console.log('login result',res.data)
        let value = res.data.token;
        localStorage.setItem("role", res.data.role);
        let webSiteTitle;
        this.accountList.forEach(value => {
          if (this.currentAccount === value.value) {
            webSiteTitle = value.text;
            localStorage.setItem("webSiteTitle", webSiteTitle);
          }
        });
        if (value) {
          this.xy.setCookie(value);
          if (this.xy.getCookie(".XYTOKEN")) {
            this.xy.msgSuc("登录成功");
            // let routers = res.data.role === 4 ? "/xyParent" : "/xyIndex";
            // this.$router.push(routers);
            // this.$router.push({path:'/home/visitList'});
               this.$router.push({path:'/home/VisitApplyDetails'});
          } else {
            this.xy.msgError("登录失败");
          }
        } else {
          this.xy.msgError("登录失败");
        }
      } else {
        this.xy.msgError("登录失败");
      }
    },
    visitBtn() {
      console.log(22)
      this.$router.push('visitLogin')
    },
    //获取单个校区信息
    async getOneAccountInfo() {
      this.xy.loading();
      let res = await this.xyapi.get(
        this.xyMApi + "/xy/login/AccountInfo"
      );
      if (res.success) {
        window.localStorage.setItem("webSiteTitle", res.data.AccountName);
        //this.xy.setCookie(".ACCOUNTNAME", res.data.AccountName);
        // 获取微信推送消息id
        this.xy.parseQueryString();
        let msgUrl = window.location.href.split("?"),
          msgOpenUrl = "";
        if (msgUrl[1].indexOf("MessageID") > -1) {
          msgOpenUrl = msgUrl[1].split("MessageID=");
          msgOpenUrl = msgOpenUrl[1];
        }
        if (msgOpenUrl) {
          window.localStorage.setItem("msgUrl", msgOpenUrl);
        } else {
          window.localStorage.setItem("msgUrl", "");
        }

        if (this.xy.getCookie(".XYTOKEN")) {
          // let routers =
          //   localStorage.getItem("role") === "4" ? "/xyParent" : "/xyIndex";
          //this.$router.push({path:'/home/visitList'});
            this.$router.push({path:'/home/VisitApplyDetails'});
        } else {
          this.xy.msgError("登录失败");
        }
      } else {
        this.$notify({ type: "danger", message: res.msg });
      }
      this.xy.unloading();
    },
    //获取所有校区信息
    async getAccountInfo() {
      this.xy.loading();
      let res = await this.xyapi.get(
        this.xyMApi + "/xy/login/AccountsInfo"
      );
      if (res.success) {
        this.accountList = [{
          text: '访客',
          value: 2
        }]
        if (!this.notInDingTalk) {
          this.dingTalkLogin();
        }
        this.currentAccount = this.accountList[0].value
      } else {
        this.$notify({ type: "danger", message: res.msg });
      }
      this.xy.unloading();
    },
    //点击访客预约
    onAppointment(){
      this.$router.push('/visitLogin')
    }
  }
};
</script>
<style lang="less">
.login {
  [class*="van-hairline"]:after {
    border: 0;
  }

  height: 100%;
  background: #fff;
  font-size: 24px;

  .van-dropdown-menu__item {
    padding-left: 46px;
    justify-content: flex-start;
  }

  .van-cell-group {
    padding: 0 32px;
  }

  .login-header {
    display: flex;

    .left {
      flex: 1;
      position: relative;

      .logo {
        width: 440px;
        height: 140px;
        position: absolute;
        left: 68px;
        top: 72px;
      }

      .account-list {
        margin-top: 500px;
      }
    }

    .right {
      width: 411px;
      height: 628px;
      background-image: url("../../../../assets/loginbg.png");
      -webkit-background-size: 100% 100%;
      background-size: 100% 100%;
    }
  }

  .login-btn {
    text-align: center;
    margin-top: 150px;

    button {
      width: 427px;
      height: 90px;
    }
  }
  .login-btn-footer{
    color: #4196ff;
    text-align: center;
    margin-top: 12%;
    font-size: 30px;
  }
}
</style>
